import { DEFAULT_CALL_CARD_FIELD_TITLES } from '../calls/callCardFields';

/**
 * Чистая часть карточки «Поля карточки звонка» в «Узлах анализа»: варианты источника,
 * подписи и признаки, которые экран показывает администратору.
 */

/**
 * Значение пункта «по умолчанию» в селекте. Radix Select не принимает пустую строку значением,
 * поэтому умолчание — отдельная метка, а на сервер уходит `null`.
 */
export const DEFAULT_SOURCE_VALUE = '__default__';

/** Значение селекта по сохранённому источнику поля. */
export const sourceSelectValue = (field) => field?.source ?? DEFAULT_SOURCE_VALUE;

/** Значение селекта → тело PUT: метка умолчания означает сброс источника. */
export const sourceFromSelectValue = (value) =>
  !value || value === DEFAULT_SOURCE_VALUE ? null : value;

const findCandidate = (candidates, path) =>
  (candidates ?? []).find((candidate) => candidate.path === path) ?? null;

/** «Узел → выход» для выбранного пути; путь как есть, если в пакете его нет. */
export const describeSource = (candidates, path) => {
  if (!path) {
    return null;
  }

  const candidate = findCandidate(candidates, path);
  return candidate ? `${candidate.nodeTitle} → ${candidate.title}` : path;
};

/**
 * Подпись пункта «по умолчанию». У «Итога звонка» умолчание — `call_outcome` triage, если он
 * есть в пакете; у «Услуги» умолчания нет, и поле заполняется только старым движком.
 */
export const defaultSourceLabel = (field, candidates) => {
  const described = describeSource(candidates, field?.defaultSource);
  return described ? `По умолчанию: ${described}` : 'По умолчанию: не заполнять';
};

/**
 * Кандидаты, сгруппированные по узлу, в порядке графа — как их прислал сервер.
 * Группа нужна, потому что у выходов разных узлов бывают одинаковые названия.
 */
export const groupCandidates = (candidates) => {
  const groups = [];
  const byNode = new Map();

  for (const candidate of candidates ?? []) {
    let group = byNode.get(candidate.nodeId);
    if (!group) {
      group = { nodeId: candidate.nodeId, nodeTitle: candidate.nodeTitle, options: [] };
      byNode.set(candidate.nodeId, group);
      groups.push(group);
    }

    group.options.push({ value: candidate.path, label: candidate.title });
  }

  return groups;
};

/**
 * Сохранённый источник, которого нет в активном пакете. Поле при этом пустое, а селекту нужен
 * пункт с этим значением — иначе Radix показал бы пустой триггер, и администратор не увидел бы,
 * что выбрано.
 */
export const orphanSource = (field) =>
  field?.source && field.sourceFound === false ? field.source : null;

/** Текст в поле названия: своё название или пусто (умолчание — плейсхолдер). */
export const titleDraft = (field) => field?.title ?? '';

/** Название по умолчанию — плейсхолдер поля и заголовок строки настройки. */
export const defaultTitle = (slot) => DEFAULT_CALL_CARD_FIELD_TITLES[slot] ?? slot;
